// =============================================================================
// 定数定義
// =============================================================================

/* =============================================================================
 * Vue
 * ===========================================================================*/
const app = new Vue({

	// 影響範囲エレメントのID
	el: "#contMain",

	/***************************************************************************
	 * 変数・データ
	 **************************************************************************/
	data: {

		/* Swiper */
		bgSwiper: {
			idName: "bgSwiper",
			className: "bgSwiper",
			isLoop: true,
			isAutoPlay: true,
			fadespeed: 2000,
			autospeed: 6000,
			allowTouchMove: false,
		},

		realSwiper: {
			idName: "realSwiper",
			className: "realSwiper",
			effect: "slide",
			isLoop: true,
		}
	},

	/***************************************************************************
	 * 初期表示時処理
	 **************************************************************************/
	created: function () {
	},

	/***************************************************************************
	 * DOM読み込み時処理
	 **************************************************************************/
	mounted: function () {
		// 上部に固定ヘッダがある場合
		smoothScrollSetting("f-menu");
	},

	/***************************************************************************
	 * 算出
	 **************************************************************************/
	computed: {
	},

	/***************************************************************************
	 * 関数
	 **************************************************************************/
	methods: {

	},

	/***************************************************************************
	 * 監視
	 **************************************************************************/
	watch: {

	},
});